export default __webpack_public_path__ + "static/media/setting_white.a676bbac.svg";